import React, {useCallback, useState} from "react";
import Scheduled from "./scheduled";
import PayCard from "./PayCard";
import Brigade from "../brigade/brigade";
import {RightBigPanelFooter} from "../../shared";
import {Button} from "../../ui-components";
import {cancelCustomerOfferBrigadeRequests, sendCustomerSentrySingleRequests} from "../requests/er-thunk";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import PatientInfo from "./PatientInfo"
import PatientCondition from "./PatientCondition"
import DestinationsContainer from "./DestinationsContainer"
import PatientDetails from "./PatientDetails"

const CreatedScheduledContent = ({request, selectedModalBrigade, isNewCard=false}) => {

  const {user} = useAppSelector(state => state.user)
  const dispatch = useAppDispatch()
  const handleSubmit = useCallback(() => {
   dispatch(sendCustomerSentrySingleRequests())
  } , [dispatch])

  const handleClose = useCallback(() => {
    dispatch(cancelCustomerOfferBrigadeRequests({item: {request_uuid: request?.uuid, customer_uuid: request?.customer_uuid}
    }))
  } , [dispatch, request?.customer_uuid, request?.uuid])

  return  <>
    <div style={{width: "50%", height: "78vh", overflow: "auto"}}>
      <Scheduled request={request}/>
      <PatientCondition request={request}/>
      <PatientDetails request={request}/>
      <PayCard request={request}/>
    </div>
    <div style={isNewCard ? {width: "50%", borderLeft: "1px solid #E7E7E7"} :{width: "50%"}}>
      <PatientInfo/>
      <DestinationsContainer request={request}/>
      {/*<Brigade selectedModalBrigade={selectedModalBrigade} />*/}
      <RightBigPanelFooter>
        <div style={{display: "flex", gap: 12, width: "100%"}}>
        <Button onClick={handleSubmit} type='contained' fullWidth>Отправить заявку в торги</Button>
        <Button onClick={handleClose} type='outlined' fullWidth>Отказать</Button>
        </div>
      </RightBigPanelFooter>
    </div>

  </>
}

export default CreatedScheduledContent
